<div class="login-container">
  <div class="flex flex-col gap-0 login-card">
    <div class="public-forms-header mb-3">
      <a href="https://www.brandshelter.com">
        <img alt="Logo" [src]="logoUrl()">
      </a>
    </div>

    <div class="p-4">
      <form [formGroup]="form" class="flex flex-col gap-5">
        <div class="flex flex-col gap-1">
          <h2 i18n="gdpr|Data Processing Agreement title">Data Processing Agreement</h2>
          <p i18n="gdpr|GDPR compliance text">To comply with the regulations of the new European General Data Protection Regulation (GDPR) effective May 25, 2018, it is required that you acknowledge and accept our Data Processing Agreement below. In case you have any question, please contact us directly.</p>
          <a href="https://www.brandshelter.com/en/new-european-data-protection" i18n="gdpr|Further information on GDPR link">Further information on GDPR</a>
          <a href="http://www.brandshelter.com/papers/Data%20Processing%20Agreement%20Key-Systems_May%202018.pdf" i18n="gdpr|Data Processing Agreement link">Data Processing Agreement</a>
        </div>
        <div class="flex flex-row gap-1">
          <p-button type="submit" (click)="onAccept()" i18n="login|Accept button">Accept</p-button>
          <p-button type="submit" (click)="onDecline()" i18n="login|Decline button">Decline</p-button>
        </div>
      </form>
   </div>
  </div>

  <app-footer-links></app-footer-links>
</div>
